import React from "react"
import propTypes from "prop-types"
import { Card, CardHeader, CardBody, Row, Col, Button } from "reactstrap"
import AsyncSelect from "react-select/async"

const TicketSelectorList = ({
    ticketSelectors,
    ticketsLoading,
    isLoading,
    handleTicketChange,
    handleRemoveSelector,
    handleAddSelector,
    loadTicketOptions,
}) => {
    // Lista desplegable para agregar o eliminar tickets a facturar
    return (
        <Card className="mb-3">
            <CardHeader className="py-2">
                <h5 className="mb-0">Tickets a facturar:</h5>
            </CardHeader>
            <CardBody className="p-3">
                {ticketSelectors.map((selector, index) => {
                    const selectedOption = selector.ticketOption || null
                    
                    return (
                        <Row key={selector.id} className={index > 0 ? "mt-3" : ""}>
                            <Col md="10">
                                <AsyncSelect
                                    key={`${selector.id}-${ticketsLoading ? "loading" : "ready"}`}
                                    value={selectedOption}
                                    onChange={(selectedOption) => handleTicketChange(
                                        selector.id, 
                                        selectedOption || null
                                    )}
                                    loadOptions={(inputValue) => loadTicketOptions(inputValue, selector.id)}
                                    defaultOptions
                                    isClearable={true}
                                    cacheOptions={false}
                                    isDisabled={ticketsLoading || isLoading}
                                    isLoading={ticketsLoading}
                                    placeholder={ticketsLoading ? "Cargando..." : 
                                        "Busca por número de ticket o cliente..."}
                                    noOptionsMessage={() => "No se encontraron tickets"}
                                    loadingMessage={() => "Buscando tickets..."}
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            minHeight: "38px",
                                        })
                                    }}
                                />
                            </Col>
                            <Col md="2" className="d-flex justify-content-center">
                                <Button 
                                    color="danger" 
                                    size="sm"
                                    onClick={() => handleRemoveSelector(selector.id)} 
                                    disabled={isLoading}
                                >
                                    <i className="fa fa-trash" />
                                </Button>
                            </Col>
                        </Row>
                    )
                })}
                
                <Row className="mt-3">
                    <Col md="12">
                        <Button 
                            color="success" 
                            onClick={handleAddSelector} 
                            disabled={isLoading}
                        >
                            <i className="fa fa-plus me-2" />
                            Agregar otro ticket
                        </Button>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    )
}

TicketSelectorList.propTypes = {
    ticketSelectors: propTypes.array.isRequired,
    ticketsLoading: propTypes.bool.isRequired,
    isLoading: propTypes.bool.isRequired,
    handleTicketChange: propTypes.func.isRequired,
    handleRemoveSelector: propTypes.func.isRequired,
    handleAddSelector: propTypes.func.isRequired,
    loadTicketOptions: propTypes.func.isRequired,
}

export default TicketSelectorList
